module.exports = __webpack_public_path__ + "static/media/text.cce5d653.svg";